import KeenSlider from 'keen-slider'

const Slider = () => {
  const slider = document.getElementById('my-keen-slider')

  var elements = document.querySelectorAll('.keen-slider__slide')
  const arrowLeft = document.getElementById('arrow-left')
  const arrowRight = document.getElementById('arrow-right')
  const options = {
    slides: elements,
    slidesPerView: 3,
    break: 2,
  }

  if (slider.classList.contains('gallery')) {
    options.slides = elements.length
    options.slidesPerView = 1
    options.break = 1
    const fullscreenBtn = document.getElementById('fullscreen')
    fullscreenBtn.addEventListener('click', () =>
      toggleFullScreen(slider.parentElement),
    )
    slider.parentElement.onfullscreenchange = (e) => {
      if (
        e.target.id === slider.parentElement.id &&
        e.target.classList.contains(modalActiveClass)
      ) {
        return slider.parentElement.classList.remove(modalActiveClass)
      }
      return slider.parentElement.classList.add(modalActiveClass)
    }
  }
  new KeenSlider('#my-keen-slider', {
    slidesPerView: options.slidesPerView,
    slides: options.slides,
    loop: true,
    spacing: 26,
    duration: 1000,
    move: (s) => {
      var opacities = s.details().positions.map((slide) => slide.portion)
      Array.prototype.forEach.call(elements, function (elm, index) {
        elm.style.opacity = opacities[index]
      })
    },
    created: function (instance) {
      arrowLeft.addEventListener('click', function (e) {
        e.preventDefault()
        instance.prev()
      })
      arrowRight.addEventListener('click', function (e) {
        e.preventDefault()
        instance.next()
      })
      updateClasses(instance)
    },
    slideChanged(instance) {
      updateClasses(instance)
    },
    breakpoints: {
      '(max-width: 1050px)': {
        slidesPerView: options.break,
      },
      '(max-width: 790px)': {
        slidesPerView: 1,
        spacing: 0,
      },
    },
  })
  function updateClasses(instance) {
    const slide = instance.details().relativeSlide
    slide === 0
      ? arrowLeft.classList.add('arrow--disabled')
      : arrowLeft.classList.remove('arrow--disabled')
    slide === instance.details().size - 1
      ? arrowRight.classList.add('arrow--disabled')
      : arrowRight.classList.remove('arrow--disabled')
  }

  const modalActiveClass = 'fullscreen'

  const toggleFullScreen = (el) => {
    const requestFullScreen =
      el.requestFullscreen ||
      el.mozRequestFullScreen ||
      el.webkitRequestFullScreen ||
      el.msRequestFullscreen
    const cancelFullScreen = document.exitFullscreen()
    if (
      !el.fullscreenElement &&
      !el.mozFullScreenElement &&
      !el.webkitFullscreenElement &&
      !el.msFullscreenElement
    ) {
      return requestFullScreen.call(el)
    }
    return cancelFullScreen.call(el)
  }
}

export default Slider
